/*USAGE:
Used in helper fcs in order to get role of current reocrd
*/

export const ROLES = ['ADMIN', 'MEMBER', 'TRAINER'];
export const TRAINER_TYPES = ['TRAINER_INTERNAL', 'TRAINER_EXTERNAL'];
export const MEMBERSHIP_TYPES = ['ACTIVE', 'INACTIVE', 'DEACTIVATED'];
export const PAYMENT_STATUSES = ['INITIAL_PAYMENT_PENDING', 'DELINQUENT'];
export const USER_SEGMENT = [...ROLES, ...TRAINER_TYPES, ...MEMBERSHIP_TYPES, ...PAYMENT_STATUSES];
